import { render, staticRenderFns } from "./treePage.vue?vue&type=template&id=843873c6&scoped=true&"
import script from "./treePage.vue?vue&type=script&lang=js&"
export * from "./treePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843873c6",
  null
  
)

export default component.exports